import { getActiveNetworkOverride } from '../constants/runtime-network';
import { StakingContractType } from '../enums/staking-contract-type.enum';

export const getStakingContractAddressByType = (type: StakingContractType) => {
  const override = getActiveNetworkOverride();

  switch (type) {
    case StakingContractType.STANDARD:
      return process.env.REACT_APP_STAKE_ADDRESS;
    case StakingContractType.FLEXIBLE:
      return process.env.REACT_APP_FLEXIBLE_STAKE_ADDRESS;
    case StakingContractType.NEGATIVE:
      return process.env.REACT_APP_NEGATIVE_STAKE_ADDRESS;
    case StakingContractType.PERIODICAL:
      return override?.contracts.PERIODICAL_STAKE ?? process.env.REACT_APP_PERIODICAL_STAKE_ADDRESS;
    case StakingContractType.WHITELISTED:
      return override?.contracts.WHITELISTED_STAKE ?? process.env.REACT_APP_WHITELISTED_STAKE_ADDRESS;
    case StakingContractType.VIP:
      return override?.contracts.VIP_STAKE ?? process.env.REACT_APP_VIP_STAKE_ADDRESS;
    default:
      return process.env.REACT_APP_STAKE_ADDRESS;
  }
};
